import axios from "axios";
import { toast } from "react-hot-toast";

export const FETCH_ATTENDANCE_STATUS_REQUEST =
  "FETCH_ATTENDANCE_STATUS_REQUEST";
export const FETCH_ATTENDANCE_STATUS_SUCCESS =
  "FETCH_ATTENDANCE_STATUS_SUCCESS";
export const FETCH_ATTENDANCE_STATUS_FAILURE =
  "FETCH_ATTENDANCE_STATUS_FAILURE";

export const CHECK_IN_REQUEST = "CHECK_IN_REQUEST";
export const CHECK_IN_SUCCESS = "CHECK_IN_SUCCESS";
export const CHECK_IN_FAILURE = "CHECK_IN_FAILURE";

export const CHECK_OUT_REQUEST = "CHECK_OUT_REQUEST";
export const CHECK_OUT_SUCCESS = "CHECK_OUT_SUCCESS";
export const CHECK_OUT_FAILURE = "CHECK_OUT_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchAttendanceStatus = () => async (dispatch) => {
  dispatch({ type: FETCH_ATTENDANCE_STATUS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/user_attendance_status`,
      {
        headers: {
          authorization: token,
        },
      }
    );

    dispatch({
      type: FETCH_ATTENDANCE_STATUS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ATTENDANCE_STATUS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const checkInUser = (formData) => async (dispatch) => {
  dispatch({ type: CHECK_IN_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/check_in`, formData, {
      headers: {
        authorization: token,
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch({ type: CHECK_IN_SUCCESS, payload: response.data });
    return response.data; // ✅ Important for component
  } catch (error) {
    const errorMessage =
      error.response?.data?.meta?.message ||
      error.response?.data?.message ||
      error.message ||
      "Check-in failed";

    dispatch({ type: CHECK_IN_FAILURE, payload: errorMessage });
    toast.error(errorMessage);

    return { meta: { status: false, message: errorMessage } }; // fallback
  }
};
export const checkOutUser = (formData) => async (dispatch) => {
  dispatch({ type: CHECK_OUT_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/check_out`, formData, {
      headers: {
        authorization: token,
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch({ type: CHECK_OUT_SUCCESS, payload: response.data });
    return response.data; // ✅ Important for component
  } catch (error) {
    const errorMessage =
      error.response?.data?.meta?.message ||
      error.response?.data?.message ||
      error.message ||
      "Check-out failed";

    dispatch({ type: CHECK_OUT_FAILURE, payload: errorMessage });
    toast.error(errorMessage);

    return { meta: { status: false, message: errorMessage } }; // fallback
  }
};
